import { useContext } from 'react';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { CardRenderContext } from '@shared/components/blocks/contexts/render';
import { Pill, PillColor } from '@shared/components/pill';
import { MBTypographyStyles } from '@shared/components/typography';
import { grid } from '@shared/styles';

interface TagProps {
  label: string;
  color?: PillColor;
  archived?: boolean;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
}

export function Tag({ label, color, archived, style, textStyle }: Readonly<TagProps>) {
  const renderContext = useContext(CardRenderContext);
  const isCalendar = renderContext === 'calendar';

  const baseViewStyle: ViewStyle = isCalendar ? { margin: 0, marginRight: grid(1) } : {};
  const baseTextStyle: TextStyle = isCalendar ? MBTypographyStyles.body2 : {};

  return (
    <Pill
      round
      italic={archived}
      backgroundColor={archived ? 'backgroundGrayLight' : color}
      style={[baseViewStyle, style]}
      textStyle={[baseTextStyle, textStyle]}
    >
      {label}
    </Pill>
  );
}
